import { Link, useLocation } from "react-router-dom";

import { LANGUAGES } from "@/i18n/languages";
import { useLang } from "@/hooks/useLang";
import { buildLangPath, stripLangPrefix } from "@/utils/routeBuilders";
import { cn } from "@/lib/utils";

export default function LanguageSwitcher({ className }: { className?: string }) {
  const { lang } = useLang();
  const { pathname, hash } = useLocation();

  const pathWithoutLang = stripLangPrefix(pathname);
  const hashSuffix = hash || "";

  return (
    <div
      className={cn(
        "flex items-center space-x-1 border rounded-md overflow-hidden",
        className
      )}
    >
      {LANGUAGES.map((l) => {
        const targetPath = buildLangPath(l.code, pathWithoutLang);
        const to = `${targetPath}${hashSuffix}`;

        if (l.code === lang) {
          return (
            <button
              key={l.code}
              disabled
              className="px-2 py-1 bg-dental text-white text-sm font-medium disabled:opacity-100"
            >
              {l.label}
            </button>
          );
        }

        return (
          <Link
            key={l.code}
            to={to}
            className="px-2 py-1 hover:bg-gray-100 text-sm font-medium text-dental-dark transition-colors duration-300"
          >
            {l.label}
          </Link>
        );
      })}
    </div>
  );
}
